import DOMPurify from 'dompurify';
import type { PropsWithChildren } from 'react';

export function DangerousHtml({ children }: PropsWithChildren) {
	// eslint-disable-next-line @typescript-eslint/no-base-to-string
	const sanitizedChildren = DOMPurify.sanitize(String(children), {
		USE_PROFILES: { html: true, svg: true },
		ADD_ATTR: ['target'],
	});

	/* eslint-disable-next-line react/forbid-dom-props */
	return <span dangerouslySetInnerHTML={{ __html: sanitizedChildren }} />;
}
